import { inject, injectable } from 'tsyringe';
import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import { type IImportUsersCsvRepository } from 'application/repositorySchemas/IImportUsersCsvRepository';
import { type IImportUsersCsvClient } from 'interfaceAdapter/gatewaySchemas/IImportUsersCsvClient';

@injectable()
export class ImportUsersCsvRepository implements IImportUsersCsvRepository {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('IImportUsersCsvClient')
        public readonly importUsersCsvClient: IImportUsersCsvClient,
    ) {}

    public async post(csv_file: File, invitation_type: 'seller' | 'buyer') {
        const { data, message } = await this.importUsersCsvClient.post({
            token: this.supportUserToken.get() || '',
            csv_file,
            invitation_type,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
